import React from 'react'
import { useAppSelector } from '../../redux/hooks'
import ConnectMetamask from './ConnectMetamask'
import PayWithCrypto from './PayWithCrypto'

interface Props {
  paymentMethods: Array<any>
  bookingPrices: any
}
const PayWithCryptoContainer = ({ paymentMethods, bookingPrices }: Props) => {
  const { accounts } = useAppSelector((state) => state.common)
  const isWalletConnected = accounts && accounts.length > 0
  return (
    <div>
      <p style={{ marginBottom: 8 }}>Pay with crypto</p>
      {isWalletConnected ? <PayWithCrypto paymentMethods={paymentMethods} bookingPrices={bookingPrices} /> : <ConnectMetamask />}
    </div>
  )
}

export default PayWithCryptoContainer
